import React from 'react'

const ItemWithStatus = ({ children, statusColor, statusLabel }) => {
    return (
        <div className='white-bg pt-3 pb-3'>
            <div className='d-flex align-items-start justify-content-between'>
                <div>
                    {children}
                </div>
                <h6
                    className='badge pe-4 ps-4'
                    style={{ background: statusColor }}
                >
                    {statusLabel}
                </h6>
            </div>
        </div>
    )
}

export default ItemWithStatus